import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const useAudienceOptions = () => {
  const { t } = useTranslation('genie');

  const audiences = useSelector((state) => state.genie.audiences);

  const groups = useMemo(() => Object.keys(audiences) ?? [], [audiences]);

  return useMemo(
    () => [
      { groupLabel: null, options: [{ label: t('all'), value: '' }] },
      ...(groups?.map((group) => ({
        groupLabel: group,
        options: audiences[group].map((audience) => ({ label: audience.label, value: audience.id })),
      })) ?? []),
    ],
    [t, audiences, groups],
  );
};

export default useAudienceOptions;
